import * as React from "react";
import PropTypes from "prop-types";
import styles from "./inline-error.module.scss";

function InlineError({ title, msg }) {
  return (
    <div className={styles.inlineError}>
      <h1>{title}</h1>
      <h3>{msg}</h3>
    </div>
  );
}

InlineError.propTypes = {
  title: PropTypes.string,
  msg: PropTypes.string
};

InlineError.defaultProps = {
  title: "Oops",
  msg: "An unknown error has occurred. Please try again later."
};

export default InlineError;
